<template lang="html">
  <div class="header row">
    <div class="logo col-sm-2" @click="goBack">
      <!-- <a>青岛文联组联平台</a> -->
      <a>青岛文联协会平台</a>
    </div>
    <nav class="nav col-sm-4 col-12" v-if="user.role==3">
      <a class="nav-link active"  @click="$router.push('/')">账号信息</a>
      <a class="nav-link"  @click="$router.push('/joinNotice')">入会申请</a>
    </nav>
    <nav class="nav col-sm-4 col-12" v-else>
      <a class="nav-link active" @click="$router.push('/dataTypein')">管理审核</a>
      <a class="nav-link" @click="$router.push('management')">账号管理</a>
    </nav>
    <div class="col-sm-auto offset-sm-auto offset-lg-3 col-xl-auto col-auto">
      <div class="dropdown color-white">
        <div class="dropdown-toggle" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
          {{user.name}}
        </div>
        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
          <a class="dropdown-item" @click="isUpdate = true">修改密码</a>
          <a class="dropdown-item" @click="logout">退出</a>
        </div>
      </div>
    </div>
    <div class="col-sm-2 col-xl-auto col-auto">
      <div class="color-white text-wel">
        欢迎您！
      </div>
    </div>
    <log-out v-bind:show="alShow" v-on:close="catchClose" v-bind:msg="altips"></log-out>
    <div class="reset-box" v-if="isUpdate">
      <div class="border">
        <span class="close" @click="isUpdate = false">×</span>
        <h3>修改密码</h3>
         <div class="form-group row">
          <label for="staticEmail" class="col-sm-4 col-form-label">旧密码：</label>
          <div class="col-sm-8">
            <input type="password" class="form-control" name="psw" v-model="form.oldpwd"  placeholder="旧密码">
          </div>
        </div>
         <div class="form-group row">
          <label for="staticEmail" class="col-sm-4 col-form-label">新密码：</label>
          <div class="col-sm-8">
            <input type="password" class="form-control" name="psw" v-model="form.password"  placeholder="新密码">
          </div>
        </div>
         <div class="form-group row">
          <label for="staticEmail" class="col-sm-4 col-form-label">再输入一次：</label>
          <div class="col-sm-8">
            <input type="password" class="form-control" name="psw" v-model="form.password1"  placeholder="新密码">
          </div>
        </div>
        <div class="form-group row" style="text-align:center">
          <button @click="updatepsw" class="btn btn-primary block full-width m-b" style="margin-top: 30px">确定修改</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import logOut from './logout.vue'
export default {
  components: {
    logOut
  },
  data() {
    return {
      user: {},
      alShow: false,
      altips: '',
      form: {
        oldpwd: '',
        password: '',
        password1: ''
      },
      isUpdate: false
    }
  },
  mounted() {
    if (!this.$store.state.user.name) {
      this.$router.push('/login')
    } else {
      this.user = this.$store.state.user
    }
  },
  methods: {
    catchClose(data) {
      this.alShow = data.show
    },
    alert(msg, func) {
      this.alShow = true
      this.altips = msg
      if (typeof func === 'function') {
        func()
      }
    },
    // 修改密码
    updatepsw() {
      this.$axios.post('/api/wenlian/changepasswd', this.qs.stringify(this.form)).then(res => {
        if (res.data.result == 1) {
          this.$store.commit('logout')
          this.alert(res.data.msg, () => {
            this.$router.push('/login')
          })
        } else {
          this.alert(res.data.msg)
        }
      })
    },
    logout() {
      this.$axios.get('/api/wenlian/logout').then(res => {
        if (res.data.result == 1) {
          this.$store.commit('logout')
          this.alert(res.data.msg, () => {
            this.$router.push('/login')
          })
        }
      })
      this.$store.commit('user', '')
      this.$store.commit('logout')
      this.$router.push('/login')
    },
    goBack() {
      if (this.$store.state.user.role == 3) {
        this.$router.push('/')
      } else {
        this.$router.push('/dataTypein')
      }

    }
  }
}
</script>

<style lang="css">
.header {
  background-color: #2f4050;
  width: 100%;
  left: 0;
  top: 0;
  z-index: 1100;
  padding: 10px 20px;
  /* min-width: 960px; */
}
.header.row {
  margin-right: 0px;
  margin-left: 0px;
}
.header .logo {
  font-size: 24px;
  font-weight: bold;
  color: #fff;
  cursor: pointer;
}
.header .logo a {
  color: #fff !important;
  text-decoration: none !important;
}
.header .nav a {
  color: #a7b1c2;
}
.header .nav a:hover {
  color: #fff;
}
.header .color-white {
  color: #fff;
  line-height: 40px;
}
.dropdown:hover {
  cursor: pointer;
}
.reset-box {
  background-color: rgba(0, 0, 0, 0.5);
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 999;
}
.reset-box .border {
  padding: 20px;
  border: 1px solid #a9afb5;
  border-radius: 5px;
  width: 450px;
  /* height: 400px; */
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  background-color: #f3f3f4;
}
.border .close {
  position: absolute;
  right: 5px;
  top: 5px;
  cursor: pointer;
}
.border .close:hover {
  color: #1ab394;
}
.border h3 {
  margin-bottom: 30px;
  color: #999;
  width: 100%;
  text-align: center;
}
.btn-primary {
  background-color: #1ab394;
  border-color: #1ab394;
  color: #fff;
  width: 80%;
  margin: 0 auto;
  /* margin-top: 30px; */
}
.btn-primary:hover {
  background-color: #1ab394;
  border-color: #1ab394;
}
@media screen and (max-width: 750px) {
  .reset-box .border {
    width: 90% !important;
  }
  .col-form-label {
    text-align: left;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/header.vue